import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import logo from "./../assets/images/muvi-studio-logo.png";
import logo_new from "./../assets/images/Muvi_Logo_Blue_White.svg";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import crmicon from "../assets/images/crmicon.svg";
import baricon from "../assets/images/bar-chart.svg";
import home from "../assets/images/home.svg";
import CRM from "../assets/images/CRM.svg";
import database from "../assets/images/database.svg";
import analytics from "../assets/images/analytics.svg";
import extranet from "../assets/images/extranet.svg";
import employee from "../assets/images/employee.svg";
import partners from "../assets/images/partners.svg";
import stream from "../assets/images/stream.svg";
import hradmin from "../assets/images/hradmin.svg";
import alieAI from "../assets/images/alie-ai.svg";

class SideMenu extends Component {
	constructor(props) {
		super(props);
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		const storedPermission = localStorage.getItem("user_permission");
		const parsedPermission = storedPermission
		? storedPermission.split(",")
		: null;

		this.state = {
			isLoggedIn: false,
			hr_permission: "",
			apiUrl: this.decryptconfigdata("apiUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			userEmail: has_local_data ? localdata.user_email : "",
			userkey: "",
			storedPermission: parsedPermission,
		};
		this.logout = this.logout.bind(this);
		//    this.ssoLoginToTattle = this.ssoLoginToTattle.bind(this);
		//    this.setSsoLoginUrlForTattle = this.setSsoLoginUrlForTattle.bind(this);
		//    this.setSsoLoginUrlForTattle();
		this.ssoLoginTattle = this.ssoLoginTattle.bind(this);
	}
	//  ssoLoginToTattle(){
	//    if(this.state.tattleLink){
	//       window.open(this.state.tattleLink,'_blank');
	//    }else{
	//      // this.setSsoLoginUrlForTattle();
	//    }
	//  }
	//  setSsoLoginUrlForTattle(){
	//    fetch(this.state.apiUrl + '/HrmanagementRest/getTattleLink/userAuthKey/' + this.state.userAuthKey+'/user_id/'+this.state.userId , {
	//        method: 'POST'
	//    })
	//        .then((Response) => Response.json())
	//        .then((findresponse) => {
	//          findresponse = this.decrypt(findresponse, 1);
	//            if(findresponse['code']=='200'){
	//                this.setState({tattleLink:findresponse['data']});
	//                // window.open(findresponse['data'],'_blank');
	//            }
	//        })
	//
	//  }

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	logout() {
		localStorage.setItem("userLogin", "");
		localStorage.clear();
		<Redirect to={"/login"} />;
		window.parent.location = window.parent.location.href;
	}
	userList() {
		fetch(
			this.state.apiUrl +
			"/adminRest/GetCommonData/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				console.log('findresponse', findresponse);
				if (!findresponse.is_active) {
					console.log('is_active', findresponse.is_active);
					this.logout();
				}
				this.setState({
					hr_permission: findresponse.hr_permission,
					hr_snippet: findresponse.hr_snippet,
					quiz_expire_status: findresponse.quiz_expire_status,
					quiz_title: findresponse.quiz_title,
				});
				localStorage.setItem("quizExpireStatus", findresponse.quiz_expire_status);
				localStorage.setItem("quizStartDate", findresponse.quiz_start_date);
				localStorage.setItem("quizTitle", findresponse.quiz_title);
				localStorage.setItem("quizStatus", findresponse.quiz_status);
				localStorage.setItem("store_permission", findresponse.storepermission);
				localStorage.setItem("is_general_user", findresponse.is_general_user);
				localStorage.setItem("customer_success_permission", findresponse.customer_success_permission);
			})
			.catch((err) => console.log(err.message));
	}
	componentDidMount() {
		this.userList();
	}
	ssoLoginTattle(redirect = "support-ticket") {
		if (this.state.userkey.length == 0) {
			fetch(
				this.state.apiUrl +
				"/tattle/getUserKey/userAuthKey/" +
				this.state.userAuthKey +
				"/userId/" +
				this.state.userId,
				{
					method: "POST",
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.decrypt(findresponse, 1);
					this.setState({
						userkey: findresponse.userkey,
					});
					window.open(
						"https://tattle.muvi.com/ssologin/" +
						this.state.userkey +
						"?redirect=/tattle/" +
						redirect +
						"/list",
						"_blank"
					);
				});
		} else {
			window.open(
				"https://tattle.muvi.com/ssologin/" + this.state.userkey + "?redirect=/tattle/" + redirect + "/list",
				"_blank"
			);
		}
	}
	render() {
		return (
			<div className="left_col scroll-view">
				<div className="navbar nav_title">
					<img
						style={{
							display: "none",
						}}
						src={"https://tattle.muvi.com/ssologin/" + this.state.userId}
					/>
					<Link to="/home" className="site_title">
						<img src={logo_new} />
						{/* <span>Muvi</span> */}
					</Link>
				</div>
				<div className="clearfix"></div>
				<div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
					<div class="menu_section">
						<ul className="nav side-menu">
							<li>
								<Link to="/home">
									<img
										src={home}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Home</span>
								</Link>
							</li>
							{/*<li><Link to="/manageEmployee"><i className="fa fa-user"></i><span>Employee</span></Link></li>*/}
							<li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
									<img
										src={employee}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Employee</span>
									<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
									<li class="dropdown-item">
										<Link to="/employees">All Employee</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/groups">All Groups</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/organizationchart">Organization Chart</Link>
									</li>
									{/*<li class="dropdown-item"><Link to="/Attendance">Attendance</Link></li>*/}
									<li class="dropdown-item">
										<Link to="/snippets">Snippets</Link>
									</li>
									<li class="dropdown-item">
										<a href="/listokr">OKR</a>
									</li>
									<li class="dropdown-item">
										<Link to="/peer-review">Peer Review</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/leaveReward">Leaves & Rewards</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/activity/insights/">Activity Insights</Link>
									</li>
									{this.state.quiz_expire_status == 1 ? (
										<li class="dropdown-item">
											<a href="/Quiz">{this.state.quiz_title}</a>
										</li>
									) : (
										""
									)}
								</ul>
							</li>
							{/* <li>
								<Link to="/customers">
									<i className="fa fa-users"></i>
									<span>Customers</span>
								</Link>
							</li> */}

							<li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
									<img
										src={CRM}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>CRM</span>
									<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
									<li class="dropdown-item">
										<Link to="/accounts/list">Accounts</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/deals/list">Deals</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/chats/list">Live Chat</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/ask-sales/list">Ask Sales</Link>
									</li>
								</ul>
							</li>

							{/* <li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
								<i class="fal fa-user-plus"></i>
								<span>Leads</span>
								<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
								{/* <li class="dropdown-item">
									<Link to="/liveChat">Live Chat Transcripts</Link>
								</li>
								<li class="dropdown-item">
									<Link to="/chats/list">Live Chat Transcripts</Link>
								</li>
								</ul>
							</li> */}
							{/* <li>
								<Link to="/chats/list">
									<i class="fa fa-commenting" aria-hidden="true"></i>
									<span>Live Chat</span>
								</Link>
							</li> */}
							<li>
								<Link to="/allreseller">
									<img
										src={partners}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Partners</span>
								</Link>
							</li>
							<li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
									<img
										src={baricon}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Revenue</span>
									<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
									<li class="dropdown-item">
										<Link to="/revenue">Customer</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/revenueReseller">Reseller</Link>
									</li>
								</ul>
							</li>

							<li>
								<Link to="/analytics">
									<img
										src={analytics}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Analytics</span>
								</Link>
							</li>
							<li>
								<Link to="/stream/info">
									<img
										src={stream}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Stream Info</span>
								</Link>
							</li>
							{/* <li>
								<Link to="/features">
									<img
										src={database}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Feature Database</span>
								</Link>
							</li> */}

							{/*70483 Manage Feature*/}
							{/*<li class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown"><i class="fal fa-line-chart"></i><span>Product Management</span><span class="fa fa-chevron-down"></span></a>
                <ul class="dropdown-menu">
                   <li class="dropdown-item"><Link to="/features">Manage Feature</Link></li>
                </ul>
              </li>*/}

							{/*<li class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown"><i class="fas fa-file-alt"></i><span>ER</span><span class="fa fa-chevron-down"></span></a>
                <ul class="dropdown-menu">
                  <li class="dropdown-item"><a onClick={() => this.ssoLoginTattle('er')}>All Request</a></li>
                   <li class="dropdown-item"><Link to="/kanban">Kanban</Link></li>
                </ul>
              </li>
              <li class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown"><i class="fas fa-file-alt"></i><span>Ticketing</span><span class="fa fa-chevron-down"></span></a>
                <ul class="dropdown-menu">*/}
							{/*<li class="dropdown-item"><Link to="/tickets">Muvi One (Classic)</Link></li>*/}
							{/*<li class="dropdown-item"><a onClick={() => this.ssoLoginTattle('support-ticket')}>All tickets</a></li>
                </ul>
              </li>*/}

							{/* <li><Link to="/tickets"><i class="far fa-ticket-alt"></i><span>All Tickets</span></Link></li> */}
							{/*<li class="dropdown">
                  <a class="dropdown-toggle" data-toggle="dropdown"><i class="fas fa-certificate"></i><span>SLA</span><span class="fa fa-chevron-down"></span></a>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item"><Link to="/SlaList">SLA Configuration</Link></li>
                    <li class="dropdown-item"><Link to="/SlaDashboard">SLA Dashboard</Link></li>
                  </ul>
              </li>*/}
							{/*<li><Link to="/okr"><i class="fas fa-asterisk"></i><span>OKR</span></Link></li>
              <li><Link to="/help"><i class="fa fa-question-circle"></i><span>Manage Help Articles</span></Link></li>*/}
							{this.state.hr_permission == "yes" ? (
								<li class="dropdown">
									<a class="dropdown-toggle" data-toggle="dropdown">
										<img
											src={hradmin}
											alt="icon description"
											style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
										/>
										<span>HR Admin</span>
										<span class="fa fa-chevron-down"></span>
									</a>
									<ul class="dropdown-menu">
										<li class="dropdown-item">
											<Link to="/leaves">Leaves</Link>
										</li>
										<li class="dropdown-item">
											<Link to="/rewards">Rewards</Link>
										</li>
										<li class="dropdown-item">
											<Link to="/masters">Masters</Link>
										</li>
										{/*<li class="dropdown-item"><Link to="/performanceReviews">Peer Review</Link></li>*/}
									</ul>
								</li>
							) : (
								""
							)}
							<li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
								{/* <i class="fa fa-cog"></i> */}
								<img
									src={alieAI}
									alt="icon description"
									style={{
									marginRight: "15px",
									marginLeft: "3px",
									height: "22px",
									}}
								/>
								<span>Alie</span>
								<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
								<li class="dropdown-item">
									<Link to="/alie">Ask</Link>
								</li>
								<li class="dropdown-item">
									<Link to="/train">Train</Link>
								</li>
								<li class="dropdown-item">
									<Link to="/eval">Eval</Link>
								</li>
								</ul>
							</li>
							{/* {this.state.hr_permission == 'yes' ? <li class="message_link"><Link to="/hiring"><i class="far fa-comment-alt"></i><span>Hiring</span></Link></li> : ''}*/}
							{/* <li>
								<Link to="/leaveReward">
									<i class="fal fa-calendar-check"></i>
									<span>Leaves & Rewards</span>
								</Link>
							</li> */}
							{/*<li class="message_link"><Link to="/Message"><i class="far fa-comment-alt"></i><span>Message</span></Link></li>*/}
							<li class="dropdown">
								<a class="dropdown-toggle" data-toggle="dropdown">
									<img
										src={extranet}
										alt="icon description"
										style={{ marginRight: "15px", marginLeft: "3px", height: "22px" }}
									/>
									<span>Extranet Forms</span>
									<span class="fa fa-chevron-down"></span>
								</a>
								<ul class="dropdown-menu">
									<li class="dropdown-item">
										<Link to="/contactUs">Contact Us</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/pdfDownloads">Pdf Downloads</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/migrationrequest">Migration Request</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/livedemoRequests">Live Demo</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/hackathon">Hackathon</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/templatepurchaserequest">
											Template Purchase
											<br /> Request
										</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/allproductsrequest">All Products Request</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/sanjhrequest">Sanjh Request</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/walkin">Walkin Drives</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/PartnerContact">Partner Contacts</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/AllwebinarRequest">Webinar Registration</Link>
									</li>
									<li class="dropdown-item">
										<Link to="/MuviUltimate">Muvi Ultimate</Link>
									</li>
									{/* <li class="dropdown-item">
										<Link to="/ask-sales/list">Ask Sales</Link>
									</li> */}
									<li class="dropdown-item">
										<Link to="/joinmuvitv">Join Muvi Tv</Link>
									</li>
									<li class="dropdown-item">
                    <Link to="/rfp">RFP Template</Link>
                  </li>
								</ul>
							</li>
							{this.state.userEmail == "biswajitdas@muvi.com" ? (
								<li class="dropdown">
									<a class="dropdown-toggle" data-toggle="dropdown">
										<i class="fas fa-ellipsis-h"></i>
										<span>CustomerSuccess</span>
										<span class="fa fa-chevron-down"></span>
									</a>
									<ul class="dropdown-menu">
										<li>
											<Link to="/CustomerSuccess/PasswordChange">
												<i class="far fa-comment-alt"></i>
												<span>PasswordChange</span>
											</Link>
										</li>
										<li>
											<Link to="/CustomerSuccess/FcmChange">
												<i class="far fa-comment-alt"></i>
												<span>FcmChange</span>
											</Link>
										</li>
										<li>
											<Link to="/CustomerSuccess/DefaultPage">
												<i class="far fa-comment-alt"></i>
												<span>DefaultPage</span>
											</Link>
										</li>
									</ul>
								</li>
							) : (
								""
							)}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}
export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu.js